import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatBar from '../components/ChatBar';
import PolicyLayout from './PolicyLayout';
import {
  ADDRESS,
  COMPANY_NAME,
  POLICY_UPDATED,
  SITE_DOMAIN,
  SITE_NAME,
} from '../constants/site';

export default function TermsOfService() {
  return (
    <div className="page">
      <Header />
      <PolicyLayout
        title="Terms of Service"
        updated={POLICY_UPDATED}
        intro={`By using ${SITE_DOMAIN}, you agree to these Terms of Service. If you do not agree, please do not use this website.`}
      >
        <h2>Services</h2>
        <p>
          {SITE_NAME} provides independent third-party support and guidance related to Family Tree
          Maker software. We do not sell or license Family Tree Maker on behalf of its publisher.
        </p>

        <h2>No affiliation</h2>
        <p>
          {COMPANY_NAME} is not affiliated with, endorsed by, or sponsored by Family Tree Maker or
          its trademark owners. Product names are used for identification only.
        </p>

        <h2>User responsibilities</h2>
        <p>
          You agree to provide accurate information when contacting us and to use the website lawfully.
          You are responsible for maintaining backups of your genealogy data.
        </p>

        <h2>Disclaimer</h2>
        <p>
          Support is provided on an "as is" basis. We do not guarantee specific outcomes for every
          technical issue. Software features and compatibility may change without notice.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, {COMPANY_NAME} shall not be liable for indirect,
          incidental, or consequential damages arising from use of this website or support services.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these Terms at any time. Continued use of the website after changes constitutes
          acceptance of the revised Terms.
        </p>

        <h2>Contact</h2>
        <p>
          {COMPANY_NAME}<br />
          {ADDRESS}<br />
          {SITE_DOMAIN}
        </p>
      </PolicyLayout>
      <Footer />
      <ChatBar />
    </div>
  );
}
